export default __webpack_public_path__ + "static/media/time-icon.b698b97b.svg";